import { render, staticRenderFns } from "./onboaring-coffee-card-list.vue?vue&type=template&id=3468d500&"
import script from "./onboaring-coffee-card-list.vue?vue&type=script&lang=js&"
export * from "./onboaring-coffee-card-list.vue?vue&type=script&lang=js&"
import style0 from "./onboaring-coffee-card-list.vue?vue&type=style&index=0&id=3468d500&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports